import { MutableRefObject } from 'react';

const SHOW_APPBANNER_HEIGHT = 100;
const HIDE_APPBANNER_HEIGHT = 50;

export type FixedHeaderHeightType =
  | typeof SHOW_APPBANNER_HEIGHT
  | typeof HIDE_APPBANNER_HEIGHT;

/**
 * トグルに関する処理
 * @param ref DOM要素
 * @param openFlg 開閉フラグ
 * @param isFitContent
 * @param fixedHeaderHeight 固定の高さ
 */
export const slideToggle = (
  ref: MutableRefObject<HTMLElement | null>,
  openFlg: boolean,
  isFitContent = false,
  fixedHeaderHeight: FixedHeaderHeightType = 100
) => {
  if (!ref.current) return;
  if (openFlg) {
    ref.current.style.display = 'block';
    const fullHeight = isFitContent
      ? `calc(100% - ${fixedHeaderHeight}px)`
      : `${ref.current?.offsetHeight}px`;
    ref.current.style.overflow = 'hidden';
    ref.current.style.height = '0';

    ref.current.style.transition = 'height 0.3s ease';
    setTimeout(() => {
      if (!ref.current) return;
      ref.current.style.height = fullHeight;
    }, 0);
    setTimeout(() => {
      if (!ref.current) return;
      if (!isFitContent) {
        ref.current.style.removeProperty('height');
      }
      ref.current.style.removeProperty('transition');
      ref.current.style.removeProperty('overflow');
    }, 300);
  } else {
    ref.current.style.overflow = 'hidden';
    ref.current.style.height = isFitContent
      ? `calc(100% - ${fixedHeaderHeight}px)`
      : `${ref.current?.offsetHeight}px`;

    ref.current.style.transition =
      'height 0.3s ease, margin 0.3s ease, padding 0.3s ease';

    setTimeout(() => {
      if (!ref.current) return;
      ref.current.style.height = '0';
      ref.current.style.paddingTop = '0';
      ref.current.style.paddingBottom = '0';
      ref.current.style.marginTop = '0';
      ref.current.style.marginBottom = '0';
    }, 0);
    setTimeout(() => {
      if (!ref.current) return;
      ref.current.style.display = 'none';
      ref.current.style.removeProperty('height');
      ref.current.style.removeProperty('padding-top');
      ref.current.style.removeProperty('padding-bottom');
      ref.current.style.removeProperty('margin-top');
      ref.current.style.removeProperty('margin-bottom');
      ref.current.style.removeProperty('transition');
      ref.current.style.removeProperty('overflow');
    }, 300);
  }
};
